// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectModule_container__3Zy0c","textbox":"ProjectModule_textbox__2ORKI","content":"ProjectModule_content__21ISQ","links":"ProjectModule_links__3nnFP"};